<template lang="pug">
f7-popup(:opened='opened')
  f7-page
    popup-navigation-bar(title='ジャンルを選ぶ', @close='$emit("close")')
    f7-toolbar.narrow-down(:bottom-md='true')
      large-button.narrow-down-button(title='絞り込む', @click='onClick')
    background
      .filter-dance-kinds
        .group-filter
          labeled-check-box(
            :checked='isAcceptNewStudent',
            title='新規生徒を受付中の先生のみ表示',
            @change='toggleAcceptNewStudent'
          )
        supported-dance-kinds-query
          .check-list(slot-scope='{ supportedDanceKinds }')
            labeled-check-box(
              :checked='isAllKindsChecked',
              :disabled='isAllKindsChecked',
              title='すべてのジャンル',
              value='ALL',
              @change='onChange'
            )
            labeled-check-box(
              v-for='(danceKind, index) in supportedDanceKinds',
              :checked='selected.indexOf(danceKind) >= 0',
              :title='$t(`danceKind.${danceKind}`)',
              :key='index',
              :value='danceKind',
              @change='onChange'
            )
</template>

<style lang="scss" scoped>
.filter-dance-kinds {
  padding-top: 56px;
}
.info {
  text-align: center;
  margin: 24px 0;
}
.group-filter {
  margin: 30px 16px 10px;
  padding-bottom: 30px;
  border-bottom: 1px solid rgba(255, 255, 255, 0.08);
}
.check-list {
  display: flex;
  flex-wrap: wrap;
  margin: 0 16px 44px;

  .labeled-check-box {
    height: 56px;
    display: flex;
    align-items: center;
  }
  .labeled-check-box:first-child {
    width: 100%;
  }
  .labeled-check-box:nth-of-type(n + 2) {
    width: 50%;
  }
}
@media (min-height: 630px) and (min-width: 630px) {
  .popup:not(.popup-tablet-fullscreen) {
    width: 100%;
    height: 100%;
    left: 0;
    top: 0;
    margin-left: 0;
    margin-top: 0;
  }
}
.narrow-down {
  height: 80px !important;
  background: none;

  .narrow-down-button {
    margin: 24px !important;
    width: 100%;
  }
}
</style>

<script>
import LabeledCheckBox from '@/components/molecules/LabeledCheckBox'
import LargeButton from '@/components/atoms/LargeButton'
import SupportedDanceKindsQuery from '@/components/queries/SupportedDanceKindsQuery'

export default {
  components: { LabeledCheckBox, LargeButton, SupportedDanceKindsQuery },
  props: {
    opened: { type: Boolean },
    selectedDanceKinds: {
      type: Array,
      default: () => [],
    },
    acceptNewStudent: {
      type: Boolean,
      default: () => [],
    },
  },
  data() {
    return {
      selected: this.selectedDanceKinds,
      isAcceptNewStudent: this.acceptNewStudent,
    }
  },
  watch: {
    selectedDanceKinds(val) {
      this.selected = val
    },
    acceptNewStudent(val) {
      this.isAcceptNewStudent = val
    },
  },
  computed: {
    isAllKindsChecked() {
      return this.selected.length === 0
    },
  },
  methods: {
    onChange(event) {
      if (event.target.checked) {
        if (event.target.value === 'ALL') {
          this.selected = []
        } else {
          this.selected.push(event.target.value)
        }
      } else {
        this.unChecked(event.target.value)
      }
    },
    onClick() {
      this.$emit('click', this.selected, this.isAcceptNewStudent)
    },
    unChecked(val) {
      const index = this.selected.findIndex((v) => v === val)
      this.selected.splice(index, 1)
    },
    toggleAcceptNewStudent() {
      this.isAcceptNewStudent = !this.isAcceptNewStudent
    },
  },
}
</script>
